import QCollapseItem from './src/QCollapseItem.vue';

/* istanbul ignore next */
QCollapseItem.install = function(Vue) {
  Vue.component(QCollapseItem.name, QCollapseItem);
};

export default QCollapseItem;
